module.exports = __webpack_public_path__ + "img/stand.be5030ca.webp";